<mat-autocomplete
  #autocompleteRef="matAutocomplete"
  (optionSelected)="entrySelected($event)"
  (optionActivated)="entryActivated($event.option?.value)"
>
  <ng-template let-location="location" #option>
    <mat-option [value]="location" (mouseenter)="entryActivated(location)" (mouseleave)="entryDeactivated()">
      <span [innerHTML]="location.label" [title]="getLabel(location)"></span>
    </mat-option>
  </ng-template>
  @if (foundLocations().length === 1) {
    @for (location of foundLocations()[0].results; track location.internal?.id || location.lonLat || location.label) {
      <ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{ location: location }"></ng-container>
    }
  } @else {
    @for (group of foundLocations(); track group.config.label) {
      <mat-optgroup
        [label]="group.config.label + ' (' + group.results.length + ')'"
        (mousedown)="expandGroup(group, $event)"
      >
        <ng-container>
          @if (group.collapsed === 'peek') {
            @for (
              location of group.results | slice: 0 : 3;
              track location.internal?.id || location.lonLat || location.label
            ) {
              <ng-container
                [ngTemplateOutlet]="option"
                [ngTemplateOutletContext]="{ location: location }"
              ></ng-container>
            }
            @if (group.results.length > 3) {
              <div class="hasMore">...</div>
            }
          } @else if (!group.collapsed) {
            @for (location of group.results; track location.internal?.id || location.lonLat || location.label) {
              <ng-container
                [ngTemplateOutlet]="option"
                [ngTemplateOutletContext]="{ location: location }"
              ></ng-container>
            }
          } @else {
            <mat-option class="dummyOption"></mat-option>
          }
        </ng-container>
      </mat-optgroup>
    } @empty {
      @if (searchTerm()) {
        <mat-option disabled>{{ i18n.get('noSearchResult') }}</mat-option>
      }
    }
  }
</mat-autocomplete>
